export function createBaseStore(baseUrl, extraState = {}, extraActions = {}, extraGetters = {}) {
    return {
        state: () => ({
            data: [],
            loadedData: false,
            currentSort: [],
            ...extraState, // should always be the last item to ensure that child stores can overwrite base methods that have the same name
        }),
        getters: {
            sortedData: (state) => {
                const res = [...state.data];
                for (let col of state.currentSort) {
                    res.sort((a, b) => {
                        let modifier = col.sortDir === 'asc' ? 1 : -1;
                        if (a[col.col] < b[col.col]) return -1 * modifier;
                        if (a[col.col] > b[col.col]) return modifier;
                        return 0;
                    })
                }
                return res;
            },
            getIDs: (state) => state.data.map(i => i.id),
            getItemById: (state) => {
                return (id) => {
                    let item = state.data.find(i => i.id === id);
                    return item || {};
                }
            },
            ...extraGetters, // should always be the last item to ensure that child stores can overwrite base variables that have the same name
        },
        actions: {
            async getData(filterExpression = null) {
                try {
                    this.loadedData = true;
                    console.log(filterExpression);
                    console.log(`${baseUrl}/${filterExpression ? '?' + filterExpression : ''}`);
                    const response = await this.axios.get(`${baseUrl}/${filterExpression ? '?' + filterExpression : ''}`, {withCredentials: true});
                    this.data = response.data;
                } catch (e) {
                    console.log(e);
                    this.loadedData = false;
                }
            },
            async addItem(item) {
                try {
                    const response = await this.axios.post(`${baseUrl}/`, item);
                    this.data.push(response.data);
                } catch (e) {
                    // TODO: Set `this.loadedData` to false, whenever a call to add, update or delete fails
                    console.log(e);
                }
            },
            async deleteItem(item, requireConfirm = true, itemDescription = '') {
                try {
                    if (!requireConfirm || confirm(`Möchten Sie ${itemDescription} wirklich entfernen?`)) {
                        await this.axios.delete(`${baseUrl}/${item.id}/`);
                        this.data = this.data.filter(i => i.id !== item.id);
                    }
                } catch (e) {
                    console.log(e);
                }
            },
            async fetchItem(id) {
                try {
                    this.loadedData = true;
                    const response = await this.axios.get(`${baseUrl}/${id}/`);
                    this.data = this.data.map(i => i.id !== id ? i : response.data);
                } catch (e) {
                    console.log(e);
                    this.loadedData = false;
                }
            },
            sort(col) {
                let el = this.currentSort.find(a => a.col === col)
                if (el) {
                    if (el.sortDir === 'asc')
                        el.sortDir = 'desc';
                    else if (el.sortDir === 'desc')
                        this.currentSort.splice(this.currentSort.indexOf(el), 1);
                } else {
                    this.currentSort.push({'col': col, 'sortDir': 'asc'});
                }
            },
            async updateItem(item) {
                try {
                    const response = await this.axios.put(`${baseUrl}/${item.id}/`, item);
                    this.data = this.data.map(i => i.id !== item.id ? i : response.data);
                } catch (e) {
                    console.log(e);
                }
            },
            ...extraActions, // should always be the last item to ensure that child stores can overwrite base methods that have the same name
        }
    }
}